<template>
  <v-container ma-0 pa-0>
    <First v-if="this.content == 'home'" />
    <!--<News v-if="this.content == 'reports'" />-->
    <Reports v-if="this.showReports" :uReport="reportv" />
    <!--<Map v-if="this.showMQTT" />-->
    <!--<MQTT :key="mqttKey" v-if="this.showMQTT" />-->
    <List v-if="showList" :path="p" :selectBox="addSelect" :title="listTitle" />
    <Gallery
      v-if="showGallery"
      :path="p"
      :selectBox="addSelectGallery"
      :title="galleryTitle"
    />
    <Movies
      v-if="showMovies"
      :path="p"
      :selectBox="addSelectGallery"
      :title="galleryTitle"
    />
    <Presentation v-if="showPresentation" />
    <!--<Photo v-if="this.content == 'photo'" />-->
    <Eth v-if="this.content == 'eth'" />
    <v-card v-if="this.content == 'bco'">
      <v-card-title>
        Barbados Cloud Observatory website
      </v-card-title>
      <v-card-text>
        Max-Planck-Institut für Meteorologie, Hamburg, Germany
      </v-card-text>
      <v-container fluid>
        Website URL:
        <a href="https://barbados.mpimet.mpg.de/" target="blank"
          >https://barbados.mpimet.mpg.de/</a
        ><br />
        <br />
      </v-container>
    </v-card>
    <v-card v-if="this.content == 'coral'">
      <v-card-title>
        CORAL (Cloud-Observing Radar and Lidar) at BCO
      </v-card-title>
      <v-card-text>
        A new high-powered lidar system for measuring at the edge of a cloud
      </v-card-text>
      <v-container fluid>
        <strong
          >Interactive quicklooks of actual data from BCO CORAL lidar:</strong
        ><br />
        Low resolution:<br />
        <a
          href="http://bcoweb.mpimet.mpg.de/quicklooks/lidarql/RamanLidar-CORAL/lowResolution/co2020/co2002/coral_200204_0002_0000.html"
          target="_blank"
          >http://bcoweb.mpimet.mpg.de/quicklooks/lidarql/RamanLidar-CORAL/lowResolution/co2020/co2002/coral_200204_0002_0000.html</a
        >
        <br /><br />High resolution:<br />
        <a
          href="http://bcoweb.mpimet.mpg.de/quicklooks/lidarql/RamanLidar-CORAL/highResolution/co2020/co2002/co200204/coral_hr_200204_0600_0700.html"
          target="_blank"
          >http://bcoweb.mpimet.mpg.de/quicklooks/lidarql/RamanLidar-CORAL/highResolution/co2020/co2002/co200204/coral_hr_200204_0600_0700.html</a
        ><br />
        <br />
      </v-container>
    </v-card>
    <v-card v-if="this.content == 'ixion'">
      <v-card-title>
        IXION
      </v-card-title>
      <v-card-text>
        Online Satellite Pass Predictions
      </v-card-text>
      <v-container fluid>
        <strong
          >URL:
          <a
            href="https://climserv.ipsl.polytechnique.fr/ixion/index.php"
            target="blank"
            >https://climserv.ipsl.polytechnique.fr/ixion/index.php</a
          ></strong
        ><br /><br />IXION provide position of satellites with a great accuracy.
        But user of satellite data has no information about temporal sampling:
        when and how a location on the Earth is seen by satellite, during a
        given duration ? The IXION software, which we developed for application
        to any satellite, provides orbitography and temporal sampling: the time
        of each overpass is given, together with the positions of the satellite
        and the Sun (at the same moment), expressed as zenith and azimuth
        angles. <br /><br
      /></v-container>
    </v-card>
    <v-card v-if="this.content == 'nasa'">
      <v-card-title>
        NASA Worldview
      </v-card-title>
      <v-card-text>
        The Worldview tool from NASA's Earth Observing System Data and
        Information System
      </v-card-text>
      <v-container fluid>
        <strong
          >URL:
          <a href="https://worldview.earthdata.nasa.gov/" target="blank"
            >https://worldview.earthdata.nasa.gov/</a
          ></strong
        ><br /><br />
        Visually explore the past and the present of this dynamic planet from a
        satellite's perspective. Select from an array of stories below to learn
        more about Worldview, the satellite imagery we provide and events
        occurring around the world.
        <br /><br
      /></v-container>
    </v-card>
    <v-card v-if="this.content == 'thredds'">
      <v-card-title>
        Thredds Data Server
      </v-card-title>
      <v-card-text>
        Thredds Data Server to export EUREC4A data to Opendap
      </v-card-text>
      <v-container fluid>
        <strong
          >URL:
          <a
            href="https://observations.ipsl.fr/thredds/catalog/EUREC4A/catalog.html"
            target="blank"
            >https://observations.ipsl.fr/thredds/catalog/EUREC4A/catalog.html</a
          ></strong
        ><br /><br />
        The access is password protected.<br />The login is the name of your
        favorite campaign in lowercase and the password the name of your
        favorite island in lowercase. <br /><br
      /></v-container>
    </v-card>
    <v-card v-if="this.content == 'dropsondes-code'">
      <v-card-title>
        Source code to generate movie with GOES image and HALO dropsondes.
      </v-card-title>
      <v-container fluid>
        <strong
          >URL:
          <a href="https://github.com/bfildier/EUREC4A_movies" target="blank"
            >https://github.com/bfildier/EUREC4A_movies</a
          ></strong
        ><br /><br />
        The code is available to everyone, and can be adapted for other types of
        data, so please free to build on it if you'd like!<br /><br
      /></v-container>
    </v-card>
    <v-card v-if="this.content == 'bco-soundings-ftp'">
      <v-card-title>
        BCO soundings
      </v-card-title>
      <v-card-text>
        NetCDF files of BCO soundings
      </v-card-text>
      <v-container fluid>
        You can have access to the NetCDF files of the BCO soundings through the
        ftp server:<br />
        <a
          href="ftp://ftp-projects.zmaw.de/acpc_barbados/SOUNDINGS/Vaisala/MW41/2020/"
          target="blank"
          >ftp://ftp-projects.zmaw.de/acpc_barbados/SOUNDINGS/Vaisala/MW41/2020/</a
        >
        <br /><br /><br
      /></v-container>
    </v-card>
    <v-card v-if="this.content == 'saildrones-website'">
      <v-card-title>
        Saildrones
      </v-card-title>
      <v-card-text>
        Saildrone Mission Portal
      </v-card-text>
      <v-container fluid>
        <p>
          All information and data from saildrones are available throught the
          "Saildrone Mission Portal"
        </p>
        <strong
          >URL:
          <a
            href="https://mission.saildrone.com/missions/2130/data/timeseries?drone_id=_"
            target="blank"
            >Saildrone Mission Portal website</a
          ></strong
        ><br /><br
      /></v-container>
    </v-card>
    <v-card v-if="this.content == 'wp3d-dropsonde'">
      <v-card-title>
        Dropsondes data from WP-3D aircraft
      </v-card-title>
      <v-container fluid>
        <ul>
          <li>
            Dropsondes data from RF07:
            <a
              href="https://seb.noaa.gov/pub/flight/ASPEN_Data/20200204I1/"
              target="blank"
              >https://seb.noaa.gov/pub/flight/ASPEN_Data/20200204I1/</a
            >
          </li>
          <br />
          <li>
            Dropsondes data from RF06:
            <a
              href="https://seb.noaa.gov/pub/flight/ASPEN_Data/20200203I1/"
              target="blank"
              >https://seb.noaa.gov/pub/flight/ASPEN_Data/20200203I1/</a
            >
          </li>
          <br />
          <li>
            Dropsondes data from RF05:
            <a
              href="https://seb.noaa.gov/pub/flight/ASPEN_Data/20200131I1/"
              target="blank"
              >https://seb.noaa.gov/pub/flight/ASPEN_Data/20200131I1/</a
            >
          </li>
          <br />
          <li>
            Dropsondes data from RF04:
            <a
              href="https://seb.noaa.gov/pub/flight/ASPEN_Data/20200124I1/"
              target="blank"
              >https://seb.noaa.gov/pub/flight/ASPEN_Data/20200124I1/</a
            >
          </li>
          <br />
          <li>
            Dropsondes data from RF03:
            <a
              href="https://seb.noaa.gov/pub/flight/ASPEN_Data/20200123I1/"
              target="blank"
              >https://seb.noaa.gov/pub/flight/ASPEN_Data/20200123I1/</a
            >
          </li>
          <br />
          <li>
            Dropsondes data from RF02:
            <a
              href="https://seb.noaa.gov/pub/flight/ASPEN_Data/20200119I1/"
              target="blank"
              >https://seb.noaa.gov/pub/flight/ASPEN_Data/20200119I1/</a
            >
          </li>
          <br />
          <li>
            Dropsondes data from RF01:
            <a
              href="https://seb.noaa.gov/pub/flight/ASPEN_Data/20200117I1/"
              target="blank"
              >https://seb.noaa.gov/pub/flight/ASPEN_Data/20200117I1/</a
            >
          </li>
        </ul>
        <br />
        <br
      /></v-container>
    </v-card>
    <v-card v-if="this.content == 'uk-mo'">
      <v-card-title>
        EUREC<sup>4</sup>A forecast at Met Office
      </v-card-title>
      <v-card-text>
        This page presents raw forecast fields from many of the the Met Office
        operational and research NWP models
      </v-card-text>
      <v-container fluid>
        Website URL:
        <a
          href="http://gws-access.ceda.ac.uk/public/mo_forecasts/restricted/EUREC4A/mo_f_eurec_dtime.html"
          target="blank"
          >http://gws-access.ceda.ac.uk/public/mo_forecasts/restricted/EUREC4A/mo_f_eurec_dtime.html</a
        ><br />
        <strong
          >To get access information to connect to the website send an email to:
          lorenzo.tomassini (at) metoffice.gov.uk</strong
        ><br /><br />
      </v-container>
    </v-card>

    <v-card v-if="this.content == 'rv-rhb-web'">
      <v-card-title>
        Data Plots from the PMEL Aerosol Group on the R/V Ronald H. Brown
      </v-card-title>
      <v-container fluid>
        <strong
          >URL:
          <a
            href="https://saga.pmel.noaa.gov/Field/underwaydata/ATOMIC/AtomicPlot/"
            target="blank"
            >https://saga.pmel.noaa.gov/Field/underwaydata/ATOMIC/AtomicPlot/</a
          ></strong
        ><br /><br
      /></v-container>
    </v-card>

    <v-card v-if="this.content == 'rv-rhb-soundings'">
      <v-card-title>
        Sounding from NOAA Ship Ronald H. Brown
      </v-card-title>
      <v-container fluid>
        <strong
          >URL:
          <a
            href="https://esrl.noaa.gov/psd/atomic/briefing/#obs"
            target="blank"
            >https://esrl.noaa.gov/psd/atomic/briefing/#obs</a
          ></strong
        ><br /><br
      /></v-container>
    </v-card>

    <div v-if="this.content == 'icon'" style="padding:20px;">
      <img
        src="photos/dei4_NARVALII_2016060600_ll_DOM01_ML-wspd_10m.gif"
        style="width:800px;"
      />
      <p>
        The animation shows convection resolving ICON simulations over the
        tropical Atlantic accompanying the NARVAL campaigns (by Daniel Klocke,
        DWD and Matthias Brueck, MPI-M). Emergent phenomena are featured in
        unprecedented detail, ranging from cold-pools of small cumuli,
        interacting squall lines of deep convection to hurricanes evolving from
        breaking easterly waves. Over 40 days are already simulated within the
        period of NARVAL-I (Dec 2013) and NARVAL-II (Aug 2016). The model
        resolution is 2.5 km with a nested domain of 1.2 km over the western
        part of the domain. These results are further used as input to
        large-eddy simulations with ICON within the HD(CP)2 project.
      </p>
    </div>

    <v-alert
      dense
      border="left"
      color="indigo"
      dark
      v-show="this.showMsg"
      v-html="msg"
      style="margin:30px 5px 5px 5px;"
    >
    </v-alert>

    <iframe
      v-if="this.showIframe"
      :src="this.url"
      width="100%"
      height="100%"
      style="height:100vh; border: none; padding: 0px; margin: 0;"
      frameBorder="0"
    />
  </v-container>
</template>

<script>
import Photo from "./Photo";
import First from "./First";
import News from "./News";
import Reports from "./Reports";
import MQTT from "./MQTT";
//import Map from "./Map";
import List from "./List";
import Gallery from "./Gallery";
import Movies from "./Movies";
import Presentation from "./Presentation";
import Eth from "./Eth";

export default {
  name: "MainFrame",
  components: {
    Photo,
    News,
    Reports,
    MQTT,
//    Map,
    List,
    Gallery,
    Movies,
    Presentation,
    First,
    Eth
  },
  props: {
    content: String
  },
  data: () => ({
    baseurl: "https://observations.ipsl.fr/aeris/eurec4aprod/",
    url: "",
    showIframe: false,
    info: [],
    p: "",
    showList: false,
    showGallery: false,
    showMovies: false,
    showPresentation: false,
    showMQTT: false,
    showReports: false,
    showMsg: false,
    msg: "",
    mqttKey: 0,
    reportv: "",
    addSelect: false,
    addSelectGallery: false,
    listTitle: "Documents"
  }),
  mounted: function() {
    this.displayContent();
  },
  methods: {
    forceRerender() {
      this.mqttKey += 1;
    },
    displayContent() {
      this.showIframe = false;
      this.showList = false;
      this.showReports = false;
      this.showMsg = false;
      this.msg = "";
      this.showMQTT = false;
      this.addSelect = false;
      this.showGallery = false;
      this.showMovies = false;
      this.showPresentation = false;

      switch (this.content) {
        case "live":
          this.forceRerender();
          this.showMQTT = true;
          break;
        case "obs-sat-goese-ir62":
          this.url =
            this.baseurl +
            "?datatype1=GOESE&datatype2=GOESE&qltype1=IR-062&qltype2=IR-062";
          this.showIframe = true;
          break;
        case "obs-sat-goese-anim":
          this.showMsg = true;
          this.msg =
            '<h3>GOES-16 Cloud Products: Barbados field campaign of "Cooperative Institute for Meteorological Satellite Studies":</h3><br /><a href="http://cimss.ssec.wisc.edu/clavrx/campaign/Barbados/" target="_blank" style="color:white">http://cimss.ssec.wisc.edu/clavrx/campaign/Barbados/</a><br /><br />';
          // this.url = "https://cimss.ssec.wisc.edu/clavrx/campaign/Barbados/";
          //this.showIframe = true;
          break;
        case "obs-sat-calipso":
          this.p = "SATELLITES_CALIPSO-LIDAR_ql";
          this.addSelect = true;
          this.listTitle = "CALIPSO LIDAR";
          this.showList = true;
          break;
        case "obs-sat-calipso-data":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SATELLITES/CALIPSO-LIDAR/";
          this.showIframe = true;
          break;
        case "obs-sat-aster-data":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SATELLITES/TERRA/ASTER/nc/";
          this.showIframe = true;
          break;
        case "obs-sat-modis":
          var today = new Date();
          let m = today.getUTCMonth() + 1;
          let m1 = "00" + m.toString();
          let d = today.getUTCDate();
          let d1 = "00" + d.toString();
          let datenow =
            today.getUTCFullYear() +
            "-" +
            m1.substring(m1.length - 2, m1.length) +
            "-" +
            d1.substring(d1.length - 2, d1.length);

          this.url =
            this.baseurl +
            "?datatype1=MODIS&datatype2=MODIS&date1=" +
            datenow +
            "&date2=" +
            datenow;
          this.showIframe = true;
          break;
        case "obs-sat-aster":
          this.url = this.baseurl + "?datatype1=ASTER&datatype2=ASTER";
          this.showIframe = true;
          break;
        case "obs-sat-smap":
          this.url = this.baseurl + "?datatype1=SMAP_DATA&datatype2=SMAP_DATA";
          this.showIframe = true;
          break;
        case "obs-sat-mur":
          this.url = this.baseurl + "?datatype1=MUR_DATA&datatype2=MUR_DATA";
          this.showIframe = true;
          break;
        case "obs-sat-smos":
          this.url = this.baseurl + "?datatype1=SMOS_DATA&datatype2=SMOS_DATA";
          this.showIframe = true;
          break;
        case "obs-sat-cls":
          this.url = this.baseurl + "?datatype1=CLS_DATA&datatype2=CLS_DATA";
          this.showIframe = true;
          break;
        case "wp3d-data":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/AIRCRAFT/WP-3/flight-data/";
          this.showIframe = true;
          break;
        case "wp3d-reports":
          this.reportv = "WP-3D";
          this.showReports = true;
          break;
        case "halo-reports":
          this.reportv = "HALO";
          this.showReports = true;
          break;
        case "atr-reports":
          this.reportv = "ATR-42";
          this.showReports = true;
          break;

        case "photo":
          this.p = "PHOTOS";
          this.galleryTitle = "Photos";
          this.addSelectGallery = true;
          this.showGallery = true;
          break;
        case "wp3d-photos":
          this.p = "AIRCRAFT_WP-3_PHOTOS";
          this.galleryTitle = "WP-3 Photos";
          this.addSelectGallery = true;
          this.showGallery = true;
          break;
        case "atr-photos":
          this.p = "AIRCRAFT_ATR_PHOTOS";
          this.galleryTitle = "ATR-42 Photos";
          this.addSelectGallery = true;
          this.showGallery = true;
          break;
        case "halo-photos":
          this.p = "AIRCRAFT_HALO_PHOTOS";
          this.galleryTitle = "HALO Photos";
          this.addSelectGallery = true;
          this.showGallery = true;
          break;
        case "halo-unified":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/AIRCRAFT/HALO/UNIFIED/";
          this.showIframe = true;
          break;
        case "twin-reports":
          this.reportv = "Twin-Otter";
          this.showReports = true;
          break;
        case "twin-photos":
          this.p = "AIRCRAFT_TWIN-OTTER_PHOTOS";
          this.galleryTitle = "Twin-otter Photos";
          this.addSelectGallery = true;
          this.showGallery = true;
          break;
        case "reports":
          this.reportv = "";
          this.showReports = true;
          break;
        case "rv-rhb-reports":
          this.reportv = "RV-RONALDHBROWN";
          this.showReports = true;
          break;
        case "bco-reports":
          this.reportv = "BCO";
          this.showReports = true;
          break;
        case "poldirad-live":
          this.showMsg = true;
          this.msg =
            'The website "POLDIRAD online" is a DLR website: <a href="https://www.pa.op.dlr.de/poldirad/eurec4a.html" target="_blank" style="color:white">https://www.pa.op.dlr.de/poldirad/eurec4a.html</a>';
          this.url = "https://www.pa.op.dlr.de/poldirad/eurec4a.html";
          this.showIframe = true;
          break;
        case "poldirad-ql":
          this.url =
            this.baseurl +
            "?datatype1=POLDIRAD&datatype2=POLDIRAD&qltype1=PPI_PCP&qltype2=PPI_PCP";
          this.showIframe = true;
          break;
        case "poldirad-ppi_pcp":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/BARBADOS/POLDIRAD/raw_data/PPI_PCP/";
          this.showIframe = true;
          break;
        case "poldirad-ppi_vol":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/BARBADOS/POLDIRAD/raw_data/PPI_VOL/";
          this.showIframe = true;
          break;
        case "poldirad-rhi_bco":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/BARBADOS/POLDIRAD/raw_data/RHI_BCO/";
          this.showIframe = true;
          break;
        case "poldirad-rhi_tar":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/BARBADOS/POLDIRAD/raw_data/RHI_TAR/";
          this.showIframe = true;
          break;
        case "poldirad-photos":
          this.p = "BARBADOS_POLDIRAD_PHOTOS";
          this.galleryTitle = "POLDIRAD Photos";
          this.addSelectGallery = true;
          this.showGallery = true;
          break;
        case "rv-atalante-reports":
          this.reportv = "RV-ATALANTE";
          this.showReports = true;
          break;
        case "rv-atalante-ceilometer":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-ATALANTE/CEILOMETER/";
          this.showIframe = true;
          break;
        case "rv-atalante-raw-ships":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-ATALANTE/RAW_DATA_Ship/";
          this.showIframe = true;
          break;
        case "rv-atalante-raw-instruments":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-ATALANTE/RAW_DATA_Instruments/";
          this.showIframe = true;
          break;
        case "rv-atalante-netcdf-instruments":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-ATALANTE/NETCTDF_Instruments/";
          this.showIframe = true;
          break;
        case "rv-atalante-atm-mast":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-ATALANTE/ATMOSPHERIC-MAST/";
          this.showIframe = true;
          break;

        case "rv-atalante-maps-sat":
          this.p = "SHIPS_RV-ATALANTE_Maps-SAT-Forecast-Ocean_2020";
          this.addSelect = true;
          this.listTitle = "Maps-SAT-Forecast-Ocean";
          this.showList = true;
          break;
        case "rv-atalante-tsg":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-ATALANTE/TRAJ/";
          this.showIframe = true;
          break;
        case "rv-atalante-tsg2":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/TSTS/FNCM/2020/";
          this.showIframe = true;
          break;
        case "rv-atalante-prxb":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/PRXB/FNCM/2020/";
          this.showIframe = true;
          break;
        case "rv-atalante-prct":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/PRCT/FNCM/2020/";
          this.showIframe = true;
          break;
        case "rv-atalante-soundingsq":
          this.url =
            this.baseurl +
            "?datatype1=ATALANTE_SOUNDING&datatype2=ATALANTE_SOUNDING";
          this.showIframe = true;
          break;
        case "rv-atalante-soundings":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-ATALANTE/RADIOSOUNDING/";
          this.showIframe = true;
          break;
        case "rv-atalante-ocarina":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-ATALANTE/OCARINA/";
          this.showIframe = true;
          break;
        case "rv-atalante-piccolo":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-ATALANTE/PICCOLO/";
          this.showIframe = true;
          break;
        case "rv-atalante-photos":
          this.p = "SHIPS_RV-ATALANTE_PHOTOS";
          this.galleryTitle = "Atalante Photos";
          this.addSelectGallery = true;
          this.showGallery = true;
          break;
        case "rv-maria-photos":
          this.p = "SHIPS_RV-MARIASMERIAN_PHOTOS";
          this.galleryTitle = "MARIA S MERIAN Photos";
          this.addSelectGallery = false;
          this.showGallery = true;
          break;
        case "rv-maria-reports":
          this.reportv = "RV-MARIASMERIAN";
          this.showReports = true;
          break;
        case "rv-maria-radar":
          this.url =
            this.baseurl + "?datatype1=MERIAN_RADAR&datatype2=MERIAN_RADAR";
          this.showIframe = true;
          break;
        case "rv-maria-cloudradar":
          this.url = "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-MARIASMERIAN/wband_radar/";
          this.showIframe = true;
          break;
        case "rv-maria-glider":
          this.showMsg = true;
          this.msg =
            'Data from GEOMAR - "GliderWeb": <a href="https://gliderweb.geomar.de/" target="_blank" style="color:white">https://gliderweb.geomar.de/</a>';
          this.url = "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-MARIASMERIAN/glider/";
          this.showIframe = true;
          break;
        case "rv-maria-drifter":
          this.url = "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-MARIASMERIAN/SVPdrifter/";
          this.showIframe = true;
          break;
        case "rv-maria-data":
          this.url = "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-MARIASMERIAN/dship/";
          this.showIframe = true;
          break;
        case "rv-maria-ctd":
          this.url = "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-MARIASMERIAN/ctd/";
          this.showIframe = true;
          break;
        case "rv-maria-uctd":
          this.url = "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-MARIASMERIAN/uctd/";
          this.showIframe = true;
          break;
        case "rv-maria-mss":
          this.url = "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-MARIASMERIAN/mss/";
          this.showIframe = true;
          break;
        case "rv-maria-mvp":
          this.url = "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-MARIASMERIAN/mvp/";
          this.showIframe = true;
          break;
        case "rv-maria-photometer":
          this.url = "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-MARIASMERIAN/photometer/";
          this.showIframe = true;
          break;
        case "rv-meteor-reports":
          this.reportv = "RV-METEOR";
          this.showReports = true;
          break;
        case "rv-rhb-data-aerosol":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-RONALDHBROWN/Aerosol_Met/2020/";
          this.showIframe = true;
          break;
        case "rv-rhb-data-lidar":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-RONALDHBROWN/lidar/";
          this.showIframe = true;
          break;
        case "rv-rhb-data-radar":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-RONALDHBROWN/radar/";
          this.showIframe = true;
          break;
        case "rv-rhb-data-ceilometer":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-RONALDHBROWN/ceilometer/";
          this.showIframe = true;
          break;
        case "rv-rhb-data-flux":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-RONALDHBROWN/flux/";
          this.showIframe = true;
          break;
        case "rv-rhb-data-radiosonde":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-RONALDHBROWN/radiosonde/";
          this.showIframe = true;
          break;
        case "rv-rhb-tsg":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-RONALDHBROWN/TRAJ/";
          this.showIframe = true;
          break;
        case "rv-rhb-tsg2":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/TSTS/WTEC/2020/";
          this.showIframe = true;
          break;
        case "rv-rhb-prxb":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/PRXB/WTEC/2020/";
          this.showIframe = true;
          break;
        case "rv-rhb-prct":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/PRCT/WTEC/2020/";
          this.showIframe = true;
          break;
        case "rv-meteor-tsg":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-METEOR/TRAJ/";
          this.showIframe = true;
          break;
        case "rv-meteor-tsg2":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/TSTS/DBBH/2020/";
          this.showIframe = true;
          break;
        case "rv-meteor-prxb":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/PRXB/DBBH/2020/";
          this.showIframe = true;
          break;
        case "rv-meteor-prct":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/PRCT/DBBH/2020/";
          this.showIframe = true;
          break;
        case "rv-maria-tsg":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-MARIASMERIAN/TRAJ/";
          this.showIframe = true;
          break;
        case "rv-maria-tsg2":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/TSTS/DBBT/2020/";
          this.showIframe = true;
          break;
        case "rv-maria-prxb":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/PRXB/DBBT/2020/";
          this.showIframe = true;
          break;
        case "rv-maria-prct":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/PRCT/DBBT/2020/";
          this.showIframe = true;
          break;
        case "sg579":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SEAGLIDERS/sg579/";
          this.showIframe = true;
          break;
        case "sg620":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SEAGLIDERS/sg620/";
          this.showIframe = true;
          break;
        case "sg637":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SEAGLIDERS/sg637/";
          this.showIframe = true;
          break;
        case "saildrones-alldata":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SAILDRONES/ATOMIC/";
          this.showIframe = true;
          break;
        case "saildrones-data":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SAILDRONES/2020/";
          this.showIframe = true;
          break;
        case "saildrones-noaa":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SAILDRONES/NOAA/";
          this.showIframe = true;
          break;
        case "saildrones-tssd":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/TSSD/";
          this.showIframe = true;
          break;
        case "caravela":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/CARAVELA/";
          this.showIframe = true;
          break;
        case "prgl":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/PRGL/";
          this.showIframe = true;
          break;
        case "buoy-nke":
          this.showMsg = true;
          this.msg =
            "The TRUSTED drifters are specially designed SVP drifters provided by EUMETSAT and manufactured by NKE with two precise water temperature measurements and a sea level pressure measurement, as well as GPS positioning";
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/BUOY/NKE/";
          this.showIframe = true;
          break;
        case "buoy-svp-bsw":
          this.showMsg = true;
          this.msg =
            "The SVP-BSW drifters are SVP drifters provided by NOAA/AOML under the ATOMIC program (PI Gregory Foltz, NOAA-AOML) and manufactured by Pacific-Gyre. They measure T and S at three subsurface levels (0.50, 5 and 10 m) as well as the wind and sea level pressure";
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/BUOY/SVP-BSW/";
          this.showIframe = true;
          break;
        case "buoy-svp-bs":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/BUOY/SVP-BS/";
          this.showIframe = true;
          break;
        case "buoy-surpact":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/BUOY/Surpact/";
          this.showIframe = true;
          break;
        case "buoy-tsdb":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/TSDB/";
          this.showIframe = true;
          break;
        case "buoy-tsdc":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/TSDC/";
          this.showIframe = true;
          break;
        case "buoy-prpf":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/PRPF/";
          this.showIframe = true;
          break;
        case "buoy-tsts":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/INSITU/TSTS/";
          this.showIframe = true;
          break;
        case "obs-model-ecmwf-precip":
          this.url =
            this.baseurl +
            "?datatype1=ECMWF-SF&datatype2=ECMWF-SF&qltype1=TP&qltype2=TP";
          this.showIframe = true;
          break;
        case "obs-model-ecmwf-pt":
          this.url =
            this.baseurl +
            "?datatype1=ECMWF-P&datatype2=ECMWF-P&qltype1=T&qltype2=T";
          this.showIframe = true;
          break;
        case "obs-model-arpege-cape":
          this.url =
            this.baseurl +
            "?datatype1=ARPEGE_MAP2D&datatype2=ARPEGE_MAP2D&qltype1=CAPE&qltype2=CAPE";
          this.showIframe = true;
          break;
        case "obs-model-arpege-pfcc":
          this.url =
            this.baseurl +
            "?datatype1=ARPEGE_MAP2DPRESSURE&datatype2=ARPEGE_MAP2DPRESSURE&qltype1=FCC&qltype2=FCC";
          this.showIframe = true;
          break;
        case "obs-model-arpege-pz":
          this.url = this.baseurl + "?datatype1=ARPEGE_Z&datatype2=ARPEGE_Z";
          this.showIframe = true;
          break;
        case "obs-model-dwd-surface":
          this.url =
            this.baseurl +
            "?datatype1=DWD&datatype2=DWD&qltype1=CAPE&qltype2=CAPE";
          this.showIframe = true;
          break;
        case "obs-model-dwd-pressure":
          this.url =
            this.baseurl +
            "?datatype1=DWD-PL&datatype2=DWD-PL&qltype1=OMEGA&qltype2=OMEGA";
          this.showIframe = true;
          break;
        case "obs-model-dwd-pz":
          this.url = this.baseurl + "?datatype1=DWD-P&datatype2=DWD-P";
          this.showIframe = true;
          break;
        case "obs-model-gfs-surface":
          this.url = this.baseurl + "?datatype1=GFS&datatype2=GFS";
          this.showIframe = true;
          break;
        case "obs-model-gfs-pressure":
          this.url = this.baseurl + "?datatype1=GFS-PL&datatype2=GFS-PL";
          this.showIframe = true;
          break;
        case "obs-model-gfs-profile":
          this.url = this.baseurl + "?datatype1=GFS-P&datatype2=GFS-P";
          this.showIframe = true;
          break;
        case "obs-model-lmdz-surface":
          this.url =
            this.baseurl +
            "?datatype1=LMDZ&datatype2=LMDZ&qltype1=cape&qltype2=cape";
          this.showIframe = true;
          break;
        case "obs-model-lmdz-pressure":
          this.url =
            this.baseurl +
            "?datatype1=LMDZ-PL&datatype2=LMDZ-PL&qltype1=hurplev&qltype2=hurplev";
          this.showIframe = true;
          break;
        case "obs-model-arome25-map2d-pl":
          this.url =
            this.baseurl +
            "?datatype1=AROME_2.5km_MAP2DPRESSURE&datatype2=AROME_2.5km_MAP2DPRESSURE&qltype1=Vertical_velocity&qltype2=Vertical_velocity";
          this.showIframe = true;
          break;
        case "obs-model-arome25-map2d":
          this.url =
            this.baseurl +
            "?datatype1=AROME_2.5km_MAP2D&datatype2=AROME_2.5km_MAP2D&qltype1=brightness_L68&qltype2=brightness_L68";
          this.showIframe = true;
          break;
        case "obs-model-arome25-evol":
          this.url =
            this.baseurl +
            "?datatype1=AROME_2.5km_EVOL&datatype2=AROME_2.5km_EVOL";
          this.showIframe = true;
          break;
        case "obs-model-arome25-p":
          this.url =
            this.baseurl +
            "?datatype1=AROME_2.5km_Z&datatype2=AROME_2.5km_Z&qltype1=CLOUD_FRACTI&qltype2=CLOUD_FRACTI";
          this.showIframe = true;
          break;
        case "obs-model-arome13-map2d-pl":
          this.url =
            this.baseurl +
            "?datatype1=AROME_1.3km_MAP2DPRESSURE&datatype2=AROME_1.3km_MAP2DPRESSURE";
          this.showIframe = true;
          break;
        case "obs-model-arome13-evol":
          this.url =
            this.baseurl +
            "?datatype1=AROME_1.3km_EVOL&datatype2=AROME_1.3km_EVOL";
          this.showIframe = true;
          break;
        case "obs-model-arome13-p":
          this.url =
            this.baseurl + "?datatype1=AROME_1.3km_Z&datatype2=AROME_1.3km_Z";
          this.showIframe = true;
          break;
        case "obs-model-arome13-map2d":
          this.url =
            this.baseurl +
            "?datatype1=AROME_1.3km_MAP2D&datatype2=AROME_1.3km_MAP2D";
          this.showIframe = true;
          break;
        case "obs-model-harmonie":
          this.url =
            this.baseurl +
            "?datatype1=HARMONIE&datatype2=HARMONIE&qltype1=U&qltype2=U";
          this.showIframe = true;
          break;
        case "obs-model-harmonie-pl":
          this.url =
            this.baseurl +
            "?datatype1=HARMONIE-PL&datatype2=HARMONIE-PL&qltype1=U_1&qltype2=U_1";
          this.showIframe = true;
          break;
        case "obs-model-icon-surface":
          this.url =
            this.baseurl +
            "?datatype1=ICON&datatype2=ICON&qltype1=cape&qltype2=cape";
          this.showIframe = true;
          break;
        case "obs-model-icon-pressure":
          this.url =
            this.baseurl +
            "?datatype1=ICON-PL&datatype2=ICON-PL&qltype1=omega&qltype2=omega";
          this.showIframe = true;
          break;
        case "obs-model-icon-profiles":
          this.url = this.baseurl + "?datatype1=ICON-P&datatype2=ICON-P";
          this.showIframe = true;
          break;
        case "obs-model-mo-surface":
          this.url = this.baseurl + "?datatype1=UKMO&datatype2=UKMO";
          this.showIframe = true;
          break;
        case "obs-model-mo-pl":
          this.url = this.baseurl + "?datatype1=UKMO-PL&datatype2=UKMO-PL";
          this.showIframe = true;
          break;
        case "obs-model-mo2-surface":
          this.url = this.baseurl + "?datatype1=UKMO2K&datatype2=UKMO2K";
          this.showIframe = true;
          break;
        case "obs-model-mo2-pl":
          this.url = this.baseurl + "?datatype1=UKMO2K-PL&datatype2=UKMO2K-PL";
          this.showIframe = true;
          break;
        case "obs-model-mo4-surface":
          this.url = this.baseurl + "?datatype1=UKMO4K&datatype2=UKMO4K";
          this.showIframe = true;
          break;
        case "obs-model-mo4-pl":
          this.url = this.baseurl + "?datatype1=UKMO4K-PL&datatype2=UKMO4K-PL";
          this.showIframe = true;
          break;
        case "obs-model-hycom-maps":
          this.url =
            this.baseurl +
            "?datatype1=Hycom_2D_Forecast&datatype2=Hycom_2D_Forecast";
          this.showIframe = true;
          break;
        case "obs-model-mercator-maps":
          this.url =
            this.baseurl +
            "?datatype1=Mercator_2D_Forecast&datatype2=Mercator_2D_Forecast";
          this.showIframe = true;
          break;
        case "obs-model-hycom-section":
          this.url =
            this.baseurl +
            "?datatype1=Hycom_Section_Forecast&datatype2=Hycom_Section_Forecast";
          this.showIframe = true;
          break;
        case "obs-model-mercator-section":
          this.url =
            this.baseurl +
            "?datatype1=Mercator_Section_Forecast&datatype2=Mercator_Section_Forecast";
          this.showIframe = true;
          break;
        case "obs-model-maps-sections":
          this.url =
            this.baseurl +
            "?datatype1=Map_Section_Forecast&datatype2=Map_Section_Forecast";
          this.showIframe = true;
          break;
        case "obs-model-p-comp":
          this.url = this.baseurl + "?datatype1=PROFILES&datatype2=PROFILES";
          this.showIframe = true;
          break;
        case "haloflights":
          //this.showIframe = true;
          this.p = "AIRCRAFT_HALO_FLIGHTS";
          this.addSelect = true;
          this.listTitle = "HALO Flights";
          this.showList = true;
          break;
        case "avap":
          //this.showIframe = true;
          this.p = "AIRCRAFT_HALO_AVAP-DROPSONDES_2020";
          this.addSelect = true;
          this.listTitle = "HALO Dropsondes";
          this.showList = true;
          break;
        case "avap-data":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/AIRCRAFT/HALO/AVAP-DROPSONDES/2020/";
          this.showIframe = true;
          break;
        case "hampradiometer":
          //this.showIframe = true;
          this.p = "AIRCRAFT_HALO_HAMP-RADIOMETER";
          this.addSelect = true;
          this.listTitle = "HAMP Radiometer";
          this.showList = true;
          break;
        case "hamp":
          //this.showIframe = true;
          this.p = "AIRCRAFT_HALO_HAMP";
          this.addSelect = true;
          this.listTitle = "HAMP Quicklooks";
          this.showList = true;
          break;
        case "walesidar":
          //this.showIframe = true;
          this.p = "AIRCRAFT_HALO_WALES-LIDAR_2020";
          this.addSelect = true;
          this.listTitle = "WALES Lidar";
          this.showList = true;
          break;
        case "bacardi":
          //this.showIframe = true;
          this.p = "AIRCRAFT_HALO_BACARDI";
          this.addSelect = true;
          this.listTitle = "BACARDI";
          this.showList = true;
          break;
        case "smart":
          //this.showIframe = true;
          this.p = "AIRCRAFT_HALO_SMART";
          this.addSelect = true;
          this.listTitle = "SMART Quicklooks";
          this.showList = true;
          break;
        case "bahamas":
          //this.showIframe = true;
          this.p = "AIRCRAFT_HALO_BAHAMAS_2020";
          this.addSelect = true;
          this.listTitle = "BAHAMAS Quicklooks";
          this.showList = true;
          break;
        case "kt-19":
          //this.showIframe = true;
          this.p = "AIRCRAFT_HALO_KT-19";
          this.addSelect = true;
          this.listTitle = "KT-19 (thermal infrared thermometer) quicklooks";
          this.showList = true;
          break;
        case "atr-lidar-ql":
          //this.showIframe = true;
          this.p = "AIRCRAFT_ATR_ALIAS_CAMPAIGN_quicklooks";
          this.addSelect = true;
          this.listTitle = "ALIAS Lidar quicklooks";
          this.showList = true;
          break;
        case "turbulence":
          //this.showIframe = true;
          this.p = "AIRCRAFT_ATR_SAFIRE-TURB_CAMPAIGN";
          this.addSelect = true;
          this.listTitle = "Turbulence";
          this.showList = true;
          break;
        case "safire-flights":
          //this.showIframe = true;
          this.p = "AIRCRAFT_ATR_SAFIRE-CORE_CAMPAIGN_FLIGHTS";
          this.addSelect = true;
          this.listTitle = "ATR-42 Flights data";
          this.showList = true;
          break;
        case "safire-radiometer":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/AIRCRAFT/ATR/SAFIRE-CLIMAT/CAMPAIGN/Radiometer-CLIMAT-CE332/";
          this.showIframe = true;
          break;
        case "atr-lidar-profil":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/AIRCRAFT/ATR/ALIAS/CAMPAIGN/data/Profil/";
          this.showIframe = true;
          break;
        case "atr-lidar-bruit":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/AIRCRAFT/ATR/ALIAS/CAMPAIGN/data/Bruit/";
          this.showIframe = true;
          break;
        case "bastaradar":
          this.p = "AIRCRAFT_ATR_BASTA_CAMPAIGN";
          this.addSelect = true;
          this.listTitle = "BASTA Radar";
          this.showList = true;
          break;
        case "microphysics":
          this.p = "AIRCRAFT_ATR_PMA_CAMPAIGN_QUICKLOOK";
          this.addSelect = true;
          this.listTitle = "Microphysics";
          this.showList = true;
          break;
        case "cloudkite":
          this.p = "CLOUDKITE_2020";
          this.addSelect = true;
          this.listTitle = "Cloudkite";
          this.showList = true;
          break;
        case "cloudkite-msm89":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/CLOUDKITE/MSM89_summary.htm";
          this.showIframe = true;
          break;
        case "cloudkite-m161":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/CLOUDKITE/M161_summary.htm";
          this.showIframe = true;
          break;
        case "marine-traffic":
          this.url =
            "https://www.marinetraffic.com/en/ais/home/centerx:-60.1/centery:13.1/zoom:7";
          this.showIframe = true;
          break;
        case "ragged-quicklooks":
          this.url =
            this.baseurl + "?datatype1=RAGGED_POINT&datatype2=RAGGED_POINT";
          this.showIframe = true;
          break;
        case "ragged-photos":
          this.p = "BARBADOS_RAGGED-POINT_PHOTOS";
          this.galleryTitle = "Ragged Point Photos";
          this.addSelectGallery = true;
          this.showGallery = true;
          break;
        case "bco-soundings":
          this.url =
            this.baseurl + "?datatype1=BCO_SOUNDING&datatype2=BCO_SOUNDING";
          this.showIframe = true;
          break;
        case "bco-picarro":
          this.p = "BARBADOS_BCO_PICARRO";
          this.addSelect = false;
          this.listTitle = "BCO PICARRO";
          this.showList = true;
          break;
        case "bco-wxt":
          this.msg = "BCO WXT";
          this.showMsg = true;
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/BARBADOS/BCO/WXT/";
          this.showIframe = true;
          break;
        case "bco-bt-ql":
          this.p = "BARBADOS_BCO_BACKTRAJECTORIES_quicklooks";
          this.addSelect = false;
          this.listTitle = "BCO Backtrajectories";
          this.showList = true;
          break;
        case "bco-bt-data":
          this.msg = "BCO Backtrajectories";
          this.showMsg = true;
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/BARBADOS/BCO/BACKTRAJECTORIES/";
          this.showIframe = true;
          break;
        case "meteor-data":
          this.msg = "Ship data (DSHIP)";
          this.showMsg = true;
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-METEOR/DSHIP/";
          this.showIframe = true;
          break;
        case "meteor-soundings":
          this.url =
            this.baseurl +
            "?datatype1=METEOR_SOUNDING&datatype2=METEOR_SOUNDING";
          this.showIframe = true;
          break;
        case "meteor-cloudradar":
          this.p = "SHIPS_RV-METEOR_cloudradar_hydrometeor-fraction";
          this.addSelect = true;
          this.listTitle = "Cloud radar & radiometer";
          this.showList = true;
          break;
        case "meteor-viscloudcam":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-METEOR/visible_cloud_camera/";
          this.showIframe = true;
          break;
        case "meteor-thermcloudcam":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-METEOR/thermal_cloud_camera/";
          this.showIframe = true;
          break;
        case "rv-atalante-viscloudcam":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-ATALANTE/visible_cloud_camera/";
          this.showIframe = true;
          break;
        case "rv-atalante-thermcloudcam":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-ATALANTE/thermal_cloud_camera/";
          this.showIframe = true;
          break;
        case "rv-maria-viscloudcam":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-MARIASMERIAN/visible_cloud_camera/";
          this.showIframe = true;
          break;
        case "rv-maria-thermcloudcam":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-MARIASMERIAN/thermal_cloud_camera/";
          this.showIframe = true;
          break;
        case "rv-maria-doppler":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-MARIASMERIAN/Doppler_Lidar/";
          this.showIframe = true;
          break;
        case "meteor-raman":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-METEOR/Raman_Lidar_LICHT/";
          this.showIframe = true;
          break;
        case "meteor-ctd":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-METEOR/CTD/";
          this.showIframe = true;
          break;
        case "meteor-adcp":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-METEOR/ADCP/";
          this.showIframe = true;
          break;
        case "meteor-gliders":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-METEOR/gliders/";
          this.showIframe = true;
          break;
        case "meteor-pax":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-METEOR/PAX/";
          this.showIframe = true;
          break;
        case "meteor-ceilometer":
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SHIPS/RV-METEOR/ceilometer/";
          this.showIframe = true;
          break;
        case "radiative-profiles":
          this.msg = "Radiative profiles for dropsondes of HALO and P3";
          this.showMsg = true;
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/PRODUCTS/RADIATIVE-PROFILES/";
          this.showIframe = true;
          break;
        case "tracks":
          this.msg = "EUREC4A incorporated measurements by 59 mobile platforms. EUREC4A tracks provides homogenized track information for each of these platforms. Files provide positional data in the form of latitude, longitude, additionally altitude/depth for non surface-bound platforms, versus time for the duration of their deployment. Airborne platform track data is segmented by flight.";
          this.showMsg = true;
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/PRODUCTS/TRACKS/";
          this.showIframe = true;
          break;
        case "movies-vis":
          this.p = "PRODUCTS=GOES-E_movies=Visible";
          this.galleryTitle = "GOES-E Movies - Visible";
          this.addSelectGallery = true;
          this.showMovies = true;
          break;
        case "movies-infra":
          this.p = "PRODUCTS=GOES-E_movies=Infrared";
          this.galleryTitle = "GOES-E Movies - Infrared";
          this.addSelectGallery = true;
          this.showMovies = true;
          break;
        case "presentation":
          this.showPresentation = true;
          break;
        case "symposium":
          this.msg =
            "<h2>&laquo;From BOMEX to EUREC4A&raquo;</h2>International sumposium at the Caribbean Insttute for Meteoroly and Hydrology - January 31 to February 1, 2020";
          this.showMsg = true;
          this.url =
            "https://observations.ipsl.fr/aeris/eurec4a-data/SYMPOSIUM/";
          this.showIframe = true;
          break;
      }
    }
  },
  computed: {
    getContent() {
      return this.content;
    }
  },
  watch: {
    getContent(newContent, oldContent) {
      this.displayContent();
    }
  }
};
</script>
